import { render, staticRenderFns } from "./check-detail.vue?vue&type=template&id=d6cff482"
import script from "./check-detail.vue?vue&type=script&lang=js"
export * from "./check-detail.vue?vue&type=script&lang=js"
import style0 from "./check-detail.vue?vue&type=style&index=0&id=d6cff482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports